module.exports = __webpack_public_path__ + "static/media/list-view.2aeaf1e2.svg";